module.exports = __webpack_public_path__ + "img/shopping-cart-regular.a74ddd0a.svg";